/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  McpExportAuthentication,
  McpExportAuthentication$inboundSchema,
} from "./mcpexportauthentication.js";
import { McpExportTool, McpExportTool$inboundSchema } from "./mcpexporttool.js";

/**
 * Complete MCP server export for documentation and integration
 */
export type McpExport = {
  /**
   * Authentication requirements for the MCP server
   */
  authentication: McpExportAuthentication;
  /**
   * Description of the MCP server
   */
  description?: string | undefined;
  /**
   * Link to external documentation
   */
  documentationUrl?: string | undefined;
  /**
   * Server instructions for users
   */
  instructions?: string | undefined;
  /**
   * URL to the server logo
   */
  logoUrl?: string | undefined;
  /**
   * The MCP server name
   */
  name: string;
  /**
   * The MCP server URL
   */
  serverUrl: string;
  /**
   * The MCP server slug
   */
  slug: string;
  /**
   * Available tools on this MCP server
   */
  tools: Array<McpExportTool>;
};

/** @internal */
export const McpExport$inboundSchema: z.ZodMiniType<McpExport, unknown> = z
  .pipe(
    z.object({
      authentication: McpExportAuthentication$inboundSchema,
      description: z.optional(z.string()),
      documentation_url: z.optional(z.string()),
      instructions: z.optional(z.string()),
      logo_url: z.optional(z.string()),
      name: z.string(),
      server_url: z.string(),
      slug: z.string(),
      tools: z.array(McpExportTool$inboundSchema),
    }),
    z.transform((v) => {
      return remap$(v, {
        "documentation_url": "documentationUrl",
        "logo_url": "logoUrl",
        "server_url": "serverUrl",
      });
    }),
  );

export function mcpExportFromJSON(
  jsonString: string,
): SafeParseResult<McpExport, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpExport$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpExport' from JSON`,
  );
}
